/**
 * Modelo para los componentes del bracket
 * 
 * Este archivo contiene constantes y utilidades utilizadas por los componentes del bracket
 */

// Constantes para los lados (local/visitante)
export const Side = {
  HOME: 'home',
  VISITOR: 'visitor'
}; 